const httpResponse = {
  success: false,
  data: null,
  message: null,
  status:null
};
export default httpResponse;
